<template>
  <CHeader fixed with-subheader light style="align-items: center">
    <!-- <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    /> -->
    <!-- <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand> -->
    <div class="logo-box sm-mr">
      <!-- <CImage fluid src="src/assets/themlg.png" /> -->
      <a href="/">
        <!-- <img src="../assets/themlg.png" alt="logo"> -->
        <div class="logo"></div>
      </a>
    </div>
    <!-- <CHeaderBrand class="mx-auto d-md-down-none" to="/">
      <CIcon name="cib-acm" height="48" alt="Logo"/>
    </CHeaderBrand> -->
    <CHeaderNav class="mr-auto ml ovs">
      <div>
        <ul class="ul-box">
          <router-link to="/dashboard" tag="li" class="ul-box-li">
            <div @click="reqMessageCount">{{ $t("navbar.Dashboard") }}</div>
          </router-link>
          <router-link v-if="primaryMark != 2" to="/funds" tag="li" class="ul-box-li">
            <div>{{ $t("navbar.Funds") }}</div>
          </router-link>
          <router-link
            to="/virtual-card/card-list"
            tag="li"
            :class="
              $route.meta.isCardpage === true
                ? 'ul-box-li router-link-exact-active'
                : 'ul-box-li'
            "
          >
            <div>{{ $t("navbar.VirtualCard") }}</div>
          </router-link>
          <router-link to="/card-detail/consumer-details" tag="li" :class="
              $route.meta.isDetailPage === true
                ? 'ul-box-li router-link-exact-active'
                : 'ul-box-li'
            ">
            <div>{{ $t("navbar.Transaction") }}</div>
          </router-link>
          <router-link v-if="primaryMark != 2" to="/account/sub-account" tag="li" :class="
              $route.meta.isSubAccountPage === true
                ? 'ul-box-li router-link-exact-active'
                : 'ul-box-li'
            ">
            <div>{{ $t("navbar.SubAccount") }}</div>
          </router-link>
          <!-- <router-link to="/account-flow" tag="li" class="ul-box-li">
            <div>{{ $t("navbar.AccountDetails") }}</div>
          </router-link> -->
          <!-- <router-link to="/account-settings" tag="li" class="ul-box-li">
            <div>{{ $t("navbar.AccountSettings") }}</div>
          </router-link> -->
          <router-link v-if="is_agent == 1" to="/reward-center/account" tag="li" :class="
              $route.meta.isRewardCenterPage === true
                ? 'ul-box-li router-link-exact-active'
                : 'ul-box-li'
            ">
            <div>{{ $t("navbar.RewardCenter") }}</div>
          </router-link>
        </ul>
      </div>
      <!-- :class="index == num ? 'px-3 active' : 'px-3'" -->

      <!-- start -->

      <!-- <CHeaderNavItem v-for="(item,index) in headerLink" :key="item.tid" :class="$route.path === item.to || $route.meta.isCardpage === item.isvPage ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink :to="item.to ? item.to : item.items[0].to">
          <div @click="getNum(item,index)">{{item.name}}</div>
          
        </CHeaderNavLink>
        
      </CHeaderNavItem> -->

      <!-- end -->

      <!-- <CHeaderNavItem :class="$route.path === item.to || $route.meta.isCardpage === item.isvPage ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="">
          <div @click="getNum(item,index)">{{item.name}}</div>
          
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <!-- <CRenderFunction flat :content-to-render="$options.nav"/> -->

      <!-- <CHeaderNavItem :class="$route.path === '/dashboard' || $route.meta.isCardpage === true ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="/dashboard">
          {{$t('navbar.Dashboard')}}
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem :class="$route.path === '/virtual-card/card-list' || $route.meta.isCardpage === true ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="/virtual-card/card-list">
          虚拟卡
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem :class="$route.path === '/consumer-details' || $route.meta.isCardpage === true ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="/consumer-details">
          消费明细
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem :class="$route.path === '/account-flow' || $route.meta.isCardpage === true ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="/account-flow">
          账户流水
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem :class="$route.path === '/account-settings' || $route.meta.isCardpage === true ? 'px-3 active' : 'px-3'">
        <CHeaderNavLink to="/account-settings">
          账户设置
        </CHeaderNavLink>
      </CHeaderNavItem> -->
    </CHeaderNav>
    <!-- d-md-down-none 移動端隱藏 -->
    <CHeaderNav class="mr-4 sm-mr">
      <!-- <CHeaderNavItem class="mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <!-- <CHeaderNavItem class="mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <!-- <span>{{$t('navbar.Dashboard')}}</span> -->
      <!-- cib-wechat -->
      <!-- <li class="el-dropdown-link" style="padding-right:20px">
        <el-popover
    placement="bottom-end"
    :title="$t('navbar.WeChatMa')"
    width="200"
    trigger="hover">

    
    
    <svg slot="reference" style="width:18px;height:18px;vertical-align: bottom;cursor:pointer" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 32 32" role="img">undefined<path d="M31.385 16.995c-0.807-1.839-2.344-3.297-4.12-4.198-3.141-1.589-7.042-1.583-10.172 0.042-2.177 1.115-3.99 3.115-4.505 5.547-0.427 1.792-0.047 3.719 0.906 5.281 1.417 2.349 3.974 3.849 6.63 4.328 1.922 0.391 3.911 0.161 5.781-0.375 1.125 0.432 2.125 1.135 3.214 1.661-0.281-0.943-0.583-1.875-0.906-2.807 1.224-0.865 2.328-1.948 2.995-3.302 0.99-1.885 1.052-4.229 0.177-6.177zM18.156 4.375c-3.328-1.87-7.469-2.151-11.047-0.859-2.354 0.849-4.479 2.422-5.797 4.563-1.193 1.932-1.641 4.344-1.063 6.552 0.573 2.453 2.281 4.51 4.349 5.885-0.401 1.135-0.781 2.266-1.141 3.406 1.297-0.677 2.599-1.391 3.901-2.078 1.557 0.5 3.219 0.745 4.88 0.688-0.443-1.255-0.542-2.62-0.339-3.932 0.297-1.828 1.297-3.5 2.656-4.74 2.302-2.156 5.563-3.063 8.661-2.844-0.583-2.844-2.583-5.25-5.099-6.641zM20.469 17.693c-0.281 0.87-1.542 1.13-2.156 0.469-0.672-0.609-0.411-1.891 0.474-2.161 0.979-0.411 2.109 0.714 1.682 1.693zM26.859 17.818c-0.339 0.781-1.521 0.964-2.099 0.359-0.281-0.255-0.359-0.641-0.458-0.974 0.135-0.609 0.557-1.245 1.24-1.271 0.938-0.13 1.781 1.031 1.297 1.885zM17.318 9.214c0.010 1.281-1.698 2.078-2.656 1.208-1-0.714-0.714-2.448 0.453-2.807 1.047-0.417 2.286 0.458 2.203 1.583zM9.24 9.536c-0.229 1.115-1.719 1.651-2.594 0.906-1.010-0.714-0.729-2.484 0.458-2.844 1.167-0.448 2.49 0.734 2.135 1.938z"></path></svg>

    <img style="width:100%;height:100%" src="../assets/official-wx.jpg" alt="關注官方支援微信" title="關注官方支援微信">
  </el-popover>
        
      </li> -->
      <!-- <li class="el-dropdown-link" style="padding-right:20px">
        <el-popover
          placement="bottom-end"
          trigger="hover">
            <div>
              <div style="padding-bottom:5px">
                <div>{{$t('navbar.TelegramTip')}} <span style="cursor:pointer;font-size:14px;font-weight:bold" @click="clickShowQRCode">{{$t('navbar.ClickToShowQRCode')}}</span></div>
              </div>
              <div>
                <div>{{$t('navbar.GfLink')}} <span style="cursor:pointer;font-size:14px;font-weight:bold" @click="clickShowChennelQRCode">{{$t('navbar.ClickToShowQRCode')}}</span></div>
              </div>
            </div>
          <svg slot="reference" style="width:18px;height:18px;vertical-align: bottom;cursor:pointer" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 32 32" role="img">undefined<path d="M29.919 6.163l-4.225 19.925c-0.319 1.406-1.15 1.756-2.331 1.094l-6.438-4.744-3.106 2.988c-0.344 0.344-0.631 0.631-1.294 0.631l0.463-6.556 11.931-10.781c0.519-0.462-0.113-0.719-0.806-0.256l-14.75 9.288-6.35-1.988c-1.381-0.431-1.406-1.381 0.288-2.044l24.837-9.569c1.15-0.431 2.156 0.256 1.781 2.013z"></path></svg>

        </el-popover>  
        </li> -->
        <li class="el-dropdown-link" style="padding-right:20px;">
        <el-popover
          placement="bottom-end"
          trigger="hover">
            <div>
              <div style="padding-bottom:5px">
                <div>{{$t('navbar.TelegramTip')}} <span style="cursor:pointer;font-size:14px;font-weight:bold" @click="clickShowQRCode">{{$t('navbar.ClickToShowQRCode')}}</span></div>
              </div>
              <div>
                <div>{{$t('navbar.GfLink')}} <span style="cursor:pointer;font-size:14px;font-weight:bold" @click="clickShowChennelQRCode">{{$t('navbar.ClickToShowQRCode')}}</span></div>
              </div>
            </div>
          <svg slot="reference" style="width:18px;height:18px;vertical-align: bottom;cursor:pointer" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 32 32" role="img">undefined<path d="M29.919 6.163l-4.225 19.925c-0.319 1.406-1.15 1.756-2.331 1.094l-6.438-4.744-3.106 2.988c-0.344 0.344-0.631 0.631-1.294 0.631l0.463-6.556 11.931-10.781c0.519-0.462-0.113-0.719-0.806-0.256l-14.75 9.288-6.35-1.988c-1.381-0.431-1.406-1.381 0.288-2.044l24.837-9.569c1.15-0.431 2.156 0.256 1.781 2.013z"></path></svg>
          <!-- <svg slot="reference" style="width:18px;height:18px;vertical-align: bottom;cursor:pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1718093688372" class="icon icon-xxl" viewBox="0 0 1024 1024" version="1.1" p-id="1468" width="" height=""><path d="M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-0.4-13.7-0.4-21.1-0.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z" p-id="1469"/><path d="M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3-41.3-41.3-89.5-73.8-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6 0.3-119.3 12.3-174.5 35.9-53.3 22.8-101.1 55.2-142 96.5-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9 0.3 69.4 16.9 138.3 48 199.9v152c0 25.4 20.6 46 46 46h152.1c61.6 31.1 130.5 47.7 199.9 48h2.1c59.9 0 118-11.6 172.7-34.3 53.5-22.3 101.6-54.3 142.8-95.2 41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5 0.3-60.9-11.5-120-34.8-175.6z m-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-0.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-0.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-0.6 99.6-39.7 192.9-110.1 262.7z" p-id="1470"/></svg> -->

        </el-popover>  
        </li>
      <el-dropdown
        @command="changeLanguage"
        style="vertical-align: middle !important;padding-right:.2rem"
      >
        
        <span class="el-dropdown-link">
          <!-- {{ locales }}<i class="el-icon-arrow-down el-icon--right"></i> -->
          <!-- <svg style="color: #000000" viewBox="64 64 896 896" data-icon="global" width="18px" height="18px" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path></svg> -->
          <img v-if="locales=='繁體'" style="vertical-align:-1px;margin-right:2px" src="@/assets/media/zh_HK.png" /><img v-else style="vertical-align:-1px;margin-right:2px" src="@/assets/media/en_GB.png" />{{locales}}
        </span>
        
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="tw"><span style="margin-right:2px"><img style="vertical-align:-1px" src="@/assets/media/zh_HK.png" /></span>繁體</el-dropdown-item>
          <el-dropdown-item command="en"><span style="margin-right:2px"><img style="vertical-align:-1px" src="@/assets/media/en_GB.png" /></span>English</el-dropdown-item>
          <!-- <el-dropdown-item command="zh">简体</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <!-- <CSubheader class="px-3 d-lg-none">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader> -->
    
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import {changeLanguages} from "../../src/api/http"
import nav from "./_nav";
export default {
  name: "TheHeader",
  nav,
  props: ["addClass"],
  data() {
    return {
      headerLink: [
        {
          tid: 0,
          name: "首頁",
          to: "/dashboard",
          index: 0,
          isvPage: false,
        },
        {
          tid: 1,
          name: "虛擬卡",
          to: "/virtual-card/card-list",
          index: 1,
          route: "/virtual-card",
          isvPage: true,
          items: [
            {
              name: "VirtualCard",
              to: "/virtual-card/card-list",
              isvPage: true,
            },
            {
              name: "創建",
              to: "/virtual-card/card-create",
              isvPage: true,
            },
          ],
        },
        {
          tid: 2,
          name: "卡明細",
          to: "/consumer-details",
          index: 2,
          isvPage: false,
        },
        {
          tid: 3,
          name: "賬戶明細",
          to: "/account-flow",
          index: 3,
          isvPage: false,
        },
        // {
        //   tid: 4,
        //   name: "賬戶設定",
        //   to: "/account-settings",
        //   index: 4,
        //   isvPage: false,
        // },
        //   {
        //   _name: 'CSidebarNavDropdown',
        //   title: 'Pages',
        //   route: '/pages',
        //   // icon: 'cil-star',
        //   tid: 5,
        //   items: [
        //     {
        //       title: 'Login',
        //       to: '/pages/login'
        //     },
        //     {
        //       title: 'Register',
        //       to: '/pages/register'
        //     },
        //     {
        //       title: 'Error 404',
        //       to: '/pages/404'
        //     },
        //     {
        //       title: 'Error 500',
        //       to: '/pages/500'
        //     }
        //   ]
        // },
      ],
      num: 0,
      acIndex: 0,
      language: 'EN'
      // visiQrCode: false
    };
  },
  methods: {
    // 显示官方Telegram二维码
    clickShowQRCode() {
      this.$confirm(this.$t('navbar.TelegramBeforeTip2'),'', {
        confirmButtonText: this.$t('navbar.TelegramTipNoted'),
        type: 'warning',
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        customClass: 'cf-class'
      }).then(() => {
        this.$store.commit('setVisiQrCode', true)
      }).catch((error) => {
        console.log(error)
      })
      
    },
    // 显示官方频道二维码
    clickShowChennelQRCode() {
      // this.$confirm(this.$t('navbar.TelegramBeforeTip'),'', {
      //   confirmButtonText: this.$t('navbar.TelegramTipNoted'),
      //   type: 'warning',
      //   showCancelButton: false,
      //   showClose: false,
      //   closeOnClickModal: false,
      //   customClass: 'cf-class'
      // }).then(() => {
      //   this.$store.commit('setVisiChannelQrCode', true)
      // }).catch((error) => {
      //   console.log(error)
      // })
      this.$store.commit('setVisiChannelQrCode', true)
      
    },
    getNum(item, key) {
      console.log("item==>", item);
      console.log("key===>", key);
      this.$emit("getData", item);
      return (this.num = key);
    },
    // 獲取私信數量
    reqMessageCount() {
      this.$store.dispatch('getUnreadCount')
    },
    // 复制
    getCopy(data) {
      let input = document.createElement("input"); // js创建一个input输入框
      input.value = data; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      this.$message({
        type: "success",
        message: "Copied",
      });
    },
    // 获取语言并且设置语言
    changeLanguage(e) {
      // location.reload();
      console.log('eessss+===>', this.$store.state)
      let str = ""
      if(e == "tw") {
        str = e.replace(e, "TC")
      }else {
        str = e.replace(e, "EN")
      }
      console.log('lange==>', str)
      let obj = {
        type: "change_language",
        lan: str
      }
      changeLanguages(obj).then((res) => {
        // console.log("lange res==>", res)
        if(res.code == 200) {
          window.localStorage.setItem("admin_lang", e == 'tw' ? 'TC' : 'EN');
          this.$i18n.locale = e;
          // window.location.reload()
        }else{
          this.$message.error(res.message)
        }
      })
      
    },
  },
  watch: {
    // 'locales':{
    //   handler(e) {
    //     if(e == 'TC') {
    //         this.$i18n.locale == "tw"
    //         this.language = '繁體'
    //     } else if(e == 'EN') {
    //         this.$i18n.locale == "en"
    //         this.language = 'EN'
    //     }else{
    //         this.$i18n.locale == "en"
    //         this.language = 'EN'
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  computed: {
    is_agent() {
      return window.localStorage.getItem('is_agent')
    },
    primaryMark() {
      return this.$store.state.primary_mark
    },
    // 国际化切换显示对应文字
    locales() {
      let language = localStorage.getItem('admin_lang')
      if(language == 'TC') {
        this.$i18n.locale == "tw"
        return '繁體'
      } else if(language == 'EN') {
        this.$i18n.locale == "en"
        return 'EN'
      }else{
        this.$i18n.locale == "en"
        return 'EN'
      }
      // if (this.$i18n.locale == "tw") {
      //   return "繁體";
      // } else if (this.$i18n.locale == "zh") {
      //   return "中文";
      // } else {
      //   // return "English";
      //   return "EN"
      // }
    },
  },
  created() {
    // console.log('nav===>', this.$options.nav)
    // console.log("i18n===>", this.$i18n.locale);
    console.log("route==>", this.$route);
    console.log('this.$store.state', this.$store.state)
  },
  components: {
    TheHeaderDropdownAccnt,
  },
};
</script>
<style lang="scss">
.cf-class{
  .el-message-box__content{
    font-weight: bold !important;
    color: #F56C6C !important;
    .el-message-box__container{
      .el-icon-warning{
        color: #F56C6C !important;
      }
    }
  }
  
}
</style>
<style scoped lang="scss">
.px-3 {
  height: 56px !important;
  line-height: 56px !important;
}
.active {
  border-bottom: 5px solid #00bea4 !important;
  color: #000;
  font-weight: 600;
}
.border-0 {
  padding: 0rem 1rem !important;
}
.logo-box {
  width: 80px;
  height: 60px;
  // margin: 0 20px;
  margin-left: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
// .ml{
//   margin-left: 3.7rem !important;
// }
.logo {
  width: 100%;
  height: 100%;
  background: url("../assets/logo02.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
}
.c-header {
  flex-wrap: nowrap;
}
.c-header-nav {
  display: -webkit-inline-box !important;
}
.child-box {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.c-box {
  display: flex;
  background: #fff;
  // height: 3rem;
  align-items: center;
  justify-content: space-around;
  color: #a3a3ab;
}
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.item-box {
  padding: 20px 0;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding-bottom: 20px;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.3rem;
}
@media screen and (max-width: 520px) {
  .ovs {
    width: 100% !important;
    overflow: hidden !important;
    overflow-x: scroll !important;
  }
  .ovs {
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 0.1rem;
    margin-bottom: -0.2rem;
    overflow: -moz-scrollbars-none;
    overflow: -moz-scrollbars-none;
  }
  .ovs::-webkit-scrollbar {
    display: none;
  }
  .sm-qu-padding {
    padding: 0;
  }
  .sm-mr {
    margin: 0 !important;
  }
}
.ac {
  background: #00bea4;
  font-weight: bold;
  color: #fff;
}
.router-link-exact-active {
  border-bottom: 5px solid #00bea4;
  color: #7f7f8a;
  font-weight: bold;
  transition: all 0.5s;
}
.ul-box {
  display: flex;
  align-items: center;
  .ul-box-li {
    height: 56px;
    line-height: 56px;
    padding: 0 1.5rem;
    cursor: pointer;
  }
}
</style>
